import { ResourceHelperService } from '../resource-helper.service';

export class CustomerSchemaService {
  public customerSchemas = [];
  public resource: ng.resource.IResourceClass<ng.resource.IResource<InterACT.Interfaces.CustomerSchemas.CustomerSchemaResponse | InterACT.Interfaces.CustomerSchemas.CustomerSchemasResponse>>;

  constructor(private $resource: ng.resource.IResourceService, private resourceHelperService: ResourceHelperService) {
    this.resource = $resource(
      'api/customer-schemas/:customerSchemaId',
      undefined,
      {
        edit: { method: 'PATCH' }, update: { method: 'PUT' }
      });
  }

  public getSchema(customerSchemaId: string) {
    return this.resource.get({ customerSchemaId: customerSchemaId }).$promise.then((resource: InterACT.Interfaces.CustomerSchemas.CustomerSchemaResponse) => {
      return resource.customerSchema;
    });
  }

  public getList(page: number, perPageCount: number, searchText?: string) {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, searchText);

    return this.resource.get(options).$promise.then((resource: InterACT.Interfaces.CustomerSchemas.CustomerSchemasResponse) => {
      this.customerSchemas = resource.customerSchemas;
      return resource.customerSchemas;
    });
  }

  public listNames() {
    return _.map(this.customerSchemas, (schema) => {
      return _.pick(schema, 'id', 'name');
    });
  }
}